import React from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../common/Buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const MoveAction = ({ data }) => {
  const navigate = useNavigate()
  const { audit_trail_id: auditTrailIdFromRoute } = useParams()
  const effectiveAuditTrailId =
    data?.audit_trail_id ?? data?.audit_trail_id_ref ?? auditTrailIdFromRoute
  const canNavigate = Boolean(effectiveAuditTrailId)

  return (
    <>
      <HeadingText heading="Associated Version" text={data.version_id} />
      <HeadingText heading="Activity" text={data.action}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button
          variant="outline-blue"
          size="sm"
          iconOnly={true}
          icon={<FontAwesomeIcon icon={faArrowRight} />}
          onClick={() => {
            if (!canNavigate) return
            let redirect = 'preview-current-node'
            if (data?.version_content?.action_to_show?.includes('_NODE_DELETED')) {
              redirect = 'preview-deleted-node'
            }
            navigate(`/audit-trail/${redirect}/${effectiveAuditTrailId}`)
          }}
          disabled={true}
        />
      </HeadingText>

      <HeadingText heading="Comment" text={data.comment} />
    </>
  )
}

export default MoveAction
